import posthog from 'posthog-js';
import appData from '@/../package.json';

const projectToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
const apiHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';
const configuredEnabled = import.meta.env.VITE_POSTHOG_ENABLED;
const appEnvironment = import.meta.env.VITE_APP_ENV || 'unknown';
const postHogConfigured = Boolean(projectToken) && configuredEnabled !== 'false';
const baseProperties = {
  app_version: appData.version,
  environment: appEnvironment,
};

export const postHogEnabled = postHogConfigured && appEnvironment === 'production';

export function initPostHog() {
  if (!postHogConfigured) {
    return;
  }

  posthog.init(projectToken, {
    api_host: apiHost,
    defaults: '2026-01-30',
    loaded: (posthogInstance) => {
      if (!postHogEnabled) {
        posthogInstance.opt_out_capturing();
        posthogInstance.set_config({disable_session_recording: true});
        return;
      }

      posthogInstance.opt_in_capturing();
    },
  });

  posthog.register(baseProperties);
}

export function capturePostHogEvent(event, properties = {}) {
  if (!postHogEnabled) {
    return;
  }

  posthog.capture(event, {
    ...baseProperties,
    ...properties,
  });
}

export function identifyPostHogUser(user) {
  if (!postHogEnabled || !user?.id) {
    return;
  }

  posthog.identify(String(user.id), {
    email: user.email,
    name: user.fullName,
  });
}

export function resetPostHog() {
  if (!postHogEnabled) {
    return;
  }

  posthog.reset();
}

export function capturePostHogException(error) {
  if (!postHogEnabled) {
    return;
  }

  posthog.captureException(error, baseProperties);
}
